import React from "react";
import { Typography, Space } from "antd";

const { Title, Text } = Typography;

interface StepHeaderProps {
  title: string;
  description: string;
  style?: React.CSSProperties;
}

const StepHeader: React.FC<StepHeaderProps> = ({ title, description, style }) => (
  <Space direction="vertical" size="small" style={style}>
    <Title level={4} style={{ margin: 0 }}>{title}</Title>
    <Text type="secondary">{description}</Text>
  </Space>
);

export default StepHeader;
